module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"back_to":"Back to "}}')
  delete Component.options._Ctor
}
